import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ApiService } from './../shared/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ngx-payment',
  
  template: `
  <style>
    @media (min-width: 768px) {
      .offset-md-3 {
        margin-left: 0%;
      }

      .col-md-6 {
          max-width: 100%;
      }
    }
  </style>
  <nb-card class="col-md-6 offset-md-3" [style.height.px]="500" status="success" accent="success" size="xsmall" [nbSpinner]="loading" nbSpinnerStatus="success" nbSpinnerSize="xlarge">
  <nb-card-header>
    <div class="row">
      <div class="col-md-5">
      </div>
      <div class="col-md-4">
        <h3 style="color:#ffffff">PAYMENT</h3>
      </div>
      <div class="col-md-3">
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row" style="margin-bottom:7px">
      <div class="col-md-3">Name</div>
      <div class="col-md-9"> 
        <input type="text" nbInput fullWidth placeholder="Name" ngModel="{{user_name}}" [readonly]="true">
      </div>
    </div>
    <div class="row" style="margin-bottom:7px">
      <div class="col-md-3">Telephone</div>
      <div class="col-md-9"> 
        <input type="text" nbInput fullWidth placeholder="Telephone" ngModel="{{mobilePayment}}" [readonly]="true">
      </div>
    </div>
    <div class="row" style="margin-bottom:7px">
      <div class="col-md-3">Email</div>
      <div class="col-md-9"> 
        <input type="text" nbInput fullWidth placeholder="Email" ngModel="{{emailPayment}}" [readonly]="true">
      </div>
    </div>
    <div class="row" style="margin-bottom:7px">
      <div class="col-md-3">Select Service Type:</div>
      <div class="col-md-9">
      <mat-form-field style="width:220px !important">
        <mat-select (selectionChange)="onChangePortal($event.source.value)" placeholder="Select Service Type" id="portal" name="portal"  ngModel="{{deliveryType}}">
          <mat-option value="digital">Emailed</mat-option>
          <mat-option value="sealed">Courier</mat-option>
    
        </mat-select>
      </mat-form-field><br>
      </div>
    </div>
    <p *ngIf="delivery == 'digital'" style="color : red">  Once the certificate is ready, we will send it to your registered Email address. ((प्रमाणपत्र तयार झाल्यावर, आम्ही ते तुमच्या नोंदणीकृत ईमेल पत्त्यावर पाठवू.)

    </p>
    <p *ngIf="delivery == 'sealed'" style="color : red">be Changed or Modified.) प्रमाणपत्र वितरण पत्ता प्रदान करा. (पत्त्यात बदल केला जाणार नाही.)</p>
    <p *ngIf="delivery == 'pickup'" style="color : red"> Select address where you want to courired your certificate.  प्रमाणपत्र तयार झाल्यावर, आम्ही तुम्हाला तुमच्या नोंदणीकृत ईमेल पत्त्यावर सूचित करू आणि तुम्ही ते विद्यापीठाकडून गोळा करू शकता</p>
    <div *ngIf="other_add !='' && isCourier">
      <label id="example-radio-group-label"><b>Select address where you want to courired your
              certificate.</b></label><br>
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
          style="display: flex; flex-direction: column;">
          <mat-radio-button class="example-radio-button" *ngFor="let add of other_add" [value]="add.address"
              (change)="onSelectaddress(add.id,add.address)">
              {{add.address}}
          </mat-radio-button><br>
      </mat-radio-group>
      <div>
          <div class="row">
              <div *ngIf="other==true">
                  <input type="checkbox" (change)='altaddCheck($event)' id="new_addressCtrl"><label>Want to
                      add different address for Courier</label>
              </div>
          </div>
      </div>
    </div>
    <form class="form" role="form" [formGroup]="secondForm" class="step-container">
        <div class="row" *ngIf="addCheck == true || alt_address == true">
            <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                Address: <span style="color:red;">*</span>
            </div>
            <div class="col-xl-6">
                <mat-form-field style="width:220px !important">
                    <input matInput formControlName="new_addressCtrl"
                        [ngClass]="{'form-control-danger': secondForm.controls.new_addressCtrl.invalid && (secondForm.controls.new_addressCtrl.dirty || secondForm.controls.new_addressCtrl.touched)}">
                </mat-form-field>
                <br />
                <p style="color:red;width:inherit;text-align: start;"
                    *ngIf="secondForm.controls['new_addressCtrl'].invalid && (secondForm.controls['new_addressCtrl'].dirty || secondForm.controls['new_addressCtrl'].touched)">
                    Please Enter Address!</p>
            </div>
        </div>
        <div class="row" *ngIf="addCheck == true || alt_address == true">
            <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                Pincode: <span style="color:red;">*</span>
            </div>
            <div class="col-xl-6">
                <mat-form-field style="width:220px !important">
                    <input pattern="[0-9]+" matInput (keyup)="pincodeChanges($event,'sealed')"
                        formControlName="new_pincodeCtrl"
                        [ngClass]="{'form-control-danger': secondForm.controls.new_pincodeCtrl.invalid && (secondForm.controls.new_pincodeCtrl.dirty || secondForm.controls.new_pincodeCtrl.touched)}">
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="addCheck == true || alt_address == true">
            <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                Area - Location: <span style="color:red;">*</span>
            </div>
            <div class="col-xl-6">
                <mat-form-field *ngIf="new_editAreaLocation == true" style="width:220px !important">
                    <input matInput formControlName="new_cityEditCtrl"
                        [ngClass]="{'form-control-danger': secondForm.controls.new_cityEditCtrl.invalid && (secondForm.controls.new_cityEditCtrl.dirty || secondForm.controls.new_cityEditCtrl.touched)}">
                </mat-form-field>
                <mat-form-field *ngIf="new_editAreaLocation == false">
                    <mat-select formControlName="new_cityCtrl">
                        <mat-option *ngFor="let new_add of new_addresses" [value]="new_add.office_name"
                            (onSelectionChange)="onChangeAreaLocation(new_add.office_name,new_add.district_name,new_add.state_name,'sealed')">{{new_add.office_name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="addCheck == true || alt_address == true">
            <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                District: <span style="color:red;">*</span>
            </div>
            <div class="col-xl-6">
                <mat-form-field style="width:220px !important">
                    <input matInput formControlName="new_districtCtrl"
                        [ngClass]="{'form-control-danger': secondForm.controls.new_districtCtrl.invalid && (secondForm.controls.new_districtCtrl.dirty || secondForm.controls.new_districtCtrl.touched)}">
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="addCheck == true || alt_address == true">
            <div class="col-xl-6" style="padding-left: 30px;padding-right: 25px;padding-top: 20px;">
                State: <span style="color:red;">*</span>
            </div>
            <div class="col-xl-6">
                <mat-form-field style="width:220px !important">
                    <input matInput formControlName="new_stateCtrl"
                        [ngClass]="{'form-control-danger': secondForm.controls.new_stateCtrl.invalid && (secondForm.controls.new_stateCtrl.dirty || secondForm.controls.new_stateCtrl.touched)}">
                </mat-form-field>
            </div>
        </div>
        <div>
            <button nbButton [disabled]="secondForm.valid===false" hero status="primary"
                *ngIf="addCheck == true || alt_address == true" (click)="save_add()">save</button>
        </div>
    </form>
    <div class="row" style="margin-bottom:7px">
      <div class="col-md-3">Amount</div>
      <div class="col-md-9"> 
      <input type="text" nbInput fullWidth placeholder="Total Amunt" ngModel="INR {{amountPayment}}" [readonly]="true"><br>
      <!--<span style ="font-weight : bold;color:red;">(INR 500 + shipping)</span><br>-->
      <span *ngIf="amountPayment != null" style ="font-weight : bold;color:red;">Fees paid are non refundable. ( भरलेली फी परत करण्यायोग्य नाही.) <br/></span>
      </div>
    </div>
    <div>
    <h6 *ngIf="amountPayment != null" style ="font-weight : bold;color:black;"> Before payment kindly check all the details filled in and go through all the documents uploaded.
    <br/>Once the payment is done you won’t be able to change/edit any of your details as well as documents.एकदा पेमेंट पूर्ण झाल्यानंतर तुम्ही तुमचे कोणतेही तपशील तसेच कागदपत्रे बदलू/संपादित करू शकणार नाही. 
    <br/>Thanks & Regards</h6>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <div class="col-md-3" style="text-align:center">
        <button nbButton hero status="primary" (click)="dismiss()">Close</button>
      </div>
      <div class="col-md-6">
        <button nbButton hero status="primary" (click)="firstpayment()">Accept And Proceed For Payment</button>
      </div>
    </div>
  </nb-card-footer>
</nb-card>
<div>
<form id="nonseamless" method="post" name="redirect" action="{{secureUrl}}"> <input type="hidden" id="encRequest" name="encRequest" value="{{encRequest}}"><input type="hidden" name="access_code" id="access_code" value="{{accessCode}}"></form>
</div>
  `
})
export class PaymentModelComponent implements OnInit {
  @Input() user_name: string;
  @Input() emailPayment: string;
  @Input() mobilePayment: string;
  @Input() amountPayment: string;
  @Input() user_id: any;
  @Input() deliveryType: any;
  @Input() address: any;
  @Input() other_add :any;
  secondForm: FormGroup;
  addCheck: boolean;
  user_data;
  loading = false;
  accessCode: any;
  secureUrl: any;
  encRequest: any;
  delivery: any;
  isCourier: boolean = false;
  isDigital: boolean = false;
  other: boolean = false;
  add_validation: boolean = false;
  new_editAreaLocation: boolean;
  new_addresses: any;
  areaLocation: any;
  alt_address: boolean;
  address_id: any;
  constructor(protected ref: NbDialogRef<PaymentModelComponent>,
    protected api : ApiService,
    public fb: FormBuilder) { }

  ngOnInit() {
    console.log("this.user_id------->"+this.user_id);
    // this.api.getUserData()
    // .subscribe(data => {
    //     this.user_data = data['data'];
    //   },
    //   error => {
    //   console.error("Error", error);
    //   }
    // )

    this.api.getAddress(this.user_id).subscribe(data=>{
      if(data['status']==200){
      this.other_add = data['data'];
      // this.amountPayment = data['amount'];
      }
    })

    this.secondForm = this.fb.group({
      new_addressCtrl : [''],
      new_cityEditCtrl : [''],
      new_cityCtrl : [''],
      new_districtCtrl : [''],
      new_stateCtrl : [''],
      new_pincodeCtrl : ['']
    })
  }

  dismiss(){
    this.ref.close();
  }

  async firstpayment(){
    this.loading = true;
    var payment = await this.api.paymentrequest(this.user_id,this.amountPayment,this.address_id , this.delivery);
    payment.subscribe(
        data => {
          this.accessCode = data['data']['accessCode'];
          this.secureUrl = data['data']['secureUrl'];
          this.encRequest = data['data']['encRequest'];
          setTimeout(function(){ 
           this.loading = false;
            var myForm = <HTMLFormElement>document.getElementById('nonseamless');
            myForm.submit();
          }, 1000);
        },
        error => {
            console.log("Error", error);
        }
    ); 
  }

  onChangePortal(value){
    this.delivery = value;
    
    if(value == 'sealed' || value == 'pickup'){
      this.isCourier = true;
      this.isDigital = false;
    }else if(value == 'digital'){
      this.isDigital = true;
      this.isCourier = false;
    }
    // this.delivery_validation = true;
    // this.delivery = value;
    // if(value == 'new'){
    //   this.delivery = 'sealed'
    // }
    // console.log("this.delivery",this.delivery);
    // if(this.delivery == 'sealed'){
    //   this.add_validation = false;
    // }else if(this.delivery == 'digital'){
    //   this.address_id = '';
    //   this.add_validation = true;
    //   console.log("thisdkjfhasldkjfsa;d",this.add_validation,";asjkdkjsd",this.delivery_validation);
    // }
    this.api.updateDelivery(value).subscribe(data=>{
      if(data['status']==200){
        this.amountPayment = data['data'];//console.log("this.anoiutksjff;laksfg",this.amountPayment);
        
      }
    })
  }

  altaddCheck(event) {
    if(event.target.checked == true){
      this.addCheck = true;
      this.alt_address = true;
      this.secondForm.controls.new_addressCtrl.setValidators([Validators.required]);
      this.secondForm.controls.new_addressCtrl.updateValueAndValidity();
      this.secondForm.controls.new_pincodeCtrl.setValidators([Validators.required, Validators.maxLength(10), Validators.minLength(5)]);
      this.secondForm.controls.new_pincodeCtrl.updateValueAndValidity();
      this.secondForm.controls.new_districtCtrl.setValidators([Validators.required]);
      this.secondForm.controls.new_districtCtrl.updateValueAndValidity();
      this.secondForm.controls.new_stateCtrl.setValidators([Validators.required]);
      this.secondForm.controls.new_stateCtrl.updateValueAndValidity();
      this.secondForm.get('new_addressCtrl').enable();
      this.secondForm.get('new_pincodeCtrl').enable();
      this.secondForm.get('new_districtCtrl').enable();
      this.secondForm.get('new_stateCtrl').enable();
    }else{
      this.addCheck = false;
      this.alt_address = false;
      this.secondForm.controls.new_addressCtrl.setValidators([]);
      this.secondForm.controls.new_addressCtrl.updateValueAndValidity();
      this.secondForm.controls.new_pincodeCtrl.setValidators([]);
      this.secondForm.controls.new_pincodeCtrl.updateValueAndValidity();
      this.secondForm.controls.new_stateCtrl.setValidators([]);
      this.secondForm.controls.new_stateCtrl.updateValueAndValidity();
      this.secondForm.controls.new_districtCtrl.setValidators([]);
      this.secondForm.controls.new_districtCtrl.updateValueAndValidity();
      this.secondForm.get('new_addressCtrl').disable();
      this.secondForm.get('new_pincodeCtrl').disable();
      this.secondForm.get('new_districtCtrl').disable();
      this.secondForm.get('new_stateCtrl').disable();
     }
  }

  onSelectaddress(event,address){
    console.log("event",event); 
    // if(event){
      if(event == 0){
        this.other = true;
      }else{
        this.address_id = address;
        this.other = false;
        this.addCheck = false;
      }
  }
  
  pincodeChanges(event,type){ 
    this.api.checkPinValues(this.secondForm.controls.new_pincodeCtrl.value)
    .subscribe(
      (data: any) => {
        if(data['status'] == 200){
          this.new_addresses = data['data'];
          console.log('new_addressesnew_addressesnew_addresses',this.new_addresses);
          
          if(this.new_addresses.length==0){
            this.new_editAreaLocation = true;
            this.secondForm.get('new_cityEditCtrl').setValidators([Validators.required]);
            this.secondForm.controls.new_cityEditCtrl.updateValueAndValidity();
            this.secondForm.get('new_cityCtrl').setValidators([]);
            this.secondForm.controls.new_cityCtrl.updateValueAndValidity();
            this.secondForm.patchValue({
              new_cityEditCtrl : ''
            })
            this.secondForm.get('new_districtCtrl').enable();
            this.secondForm.get('new_stateCtrl').enable();
          }else{
            this.new_editAreaLocation = false;
            this.secondForm.get('new_cityEditCtrl').setValidators([]);
            this.secondForm.controls.new_cityEditCtrl.updateValueAndValidity();
            this.secondForm.get('new_cityCtrl').setValidators([Validators.required]);
            this.secondForm.controls.new_cityCtrl.updateValueAndValidity();
            this.secondForm.get('new_districtCtrl').disable();
            this.secondForm.get('new_stateCtrl').disable();
          }	
        }else{
          this.secondForm.patchValue({
            new_cityCtrl : ''
          })
          this.secondForm.patchValue({
            new_districtCtrl : ''
          })
          this.secondForm.patchValue({
            new_stateCtrl : ''
          })
        }
    })
  }

  onChangeAreaLocation(location,district, state,type){ 
    this.areaLocation=location;
    console.log("district",district,"state",state);
    this.secondForm.patchValue({
      new_districtCtrl : district
    })
    this.secondForm.patchValue({
      new_stateCtrl : state
    })
    this.secondForm.patchValue({
      new_cityEditCtrl : ''
    })
  }

  save_add(){
    var newAddress={
      new_address:this.secondForm.controls.new_addressCtrl.value,
      new_pincode:this.secondForm.controls.new_pincodeCtrl.value,
      new_city:this.secondForm.controls.new_cityEditCtrl.value?this.secondForm.controls.new_cityEditCtrl.value:this.areaLocation,
      new_district:this.secondForm.controls.new_districtCtrl.value,
      new_state:this.secondForm.controls.new_stateCtrl.value,
      user_id : this.user_id
    }; // console.log("new_address",newAddress);
    
  var addAlterAdd = this.api.addAlternateAddress(newAddress,this.user_id);
  addAlterAdd.subscribe(data =>{
    if(data['status'] == 200){ console.log("data",data['id']);        
      if(data['id']!=undefined || data['id']!=''){
        this.add_validation = true;
        this.address_id = data['address'];
            
      }
    }else{

    }
  },
  err=>{
    // console.log("error",err);

  if(err){

  }
  })
  }
}
